export default __webpack_public_path__ + "static/media/L4.2a6528b4.webp";